var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-4"},[_c('div',{staticClass:"text-white pt-3"},[_c('a',{staticClass:"cursor-pointer",on:{"click":_vm.routeToGrooveSupport}},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(_vm.$t('frontend_gd_dashboard_groove_support'))))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }